import React from "react";
import styled from "styled-components";

export default function Checkbox({ required, onChange, label, checked, bold, labelbackground, labelcolor }) {
  return (
    <Label bold={bold}>
      <input
        type="checkbox"
        onChange={onChange}
        required={required ? true : false}
        checked={checked}
      />
      <Checkmark />
      <span style={{background: labelbackground, color:labelcolor}}>{label}</span>
    </Label>
  );
}

const Label = styled.label`
  display: block;
  position: relative;
  padding-left: 2em;
  height: 1em;
  line-height: 30px;
  cursor: pointer;
  user-select: none;
  color: #673b8b;
  font-size: ${props => (props.bold ? "25px" : "18px")};
  font-weight: ${props => (props.bold ? "900" : "300")};
  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
  }
  &:hover {
    input ~ span {
      background-color: ${props => props.theme.primary};
    }
  }
  input:checked ~ span {
    background-color: ${props => props.theme.primary};
    &:after {
      display: block;
    }
  }
`;

const Checkmark = styled.span`
  position: absolute;
  top: 1px;
  left: 0;
  height: 25px;
  width: 25px;
  background-color: #eeeaf5;
  border: 2px solid #af9dc4;
  border-radius: 5px;
  &:after {
    content: "";
    position: absolute;
    display: none;
    left: 10px;
    top: 4px;
    width: 5px;

    height: 11px;
    border: solid #673b8b;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
  }
`;
